/**
 * Test utilities for Sentry offline queuing
 * These can be accessed from the browser console for testing
 */

// Expose utilities to window for easy testing
if (typeof window !== 'undefined') {
  window.sentryTest = {
    /**
     * Trigger a test error to Sentry
     */
    triggerError: () => {
      try {
        throw new Error('Test error for Sentry offline queuing');
      } catch (e) {
        window.App.$sentry.captureException(e);
        console.log('[Test] Sentry error triggered');
      }
    },
    /**
     * Help message
     */
    help: () => {
      console.log(`
Sentry Offline Queue Test Utilities
====================================

Available commands:
- window.sentryTest.triggerError()     : Trigger a test error
- window.sentryTest.help()             : Show this help message
      `);
    }
  };

  // Show help on load
  console.log('[Sentry] Test utilities loaded. Run window.sentryTest.help() for instructions.');
}
